import React, {useState, useEffect} from 'react';
import { Helmet } from 'react-helmet-async';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { Grid, Container, Typography } from '@mui/material';
import { Add } from '../sections/@dashboard/manageProperty';
import { Unauthorized } from '../sections/@dashboard/manageUser';
import { getToken } from '../services/LocalStorageService';
import { useGetAllUserAccessQuery } from '../services/dvagent'
import { PropertyViewCard } from '../components/skeleton';

export default function PropertyAdd() {

  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [haveCreateAccess, setHaveCreateAccess] = useState(false)
  const { data:userAccessData, isSuccess:userAccessIsSuccess, error:userAccessError } = useGetAllUserAccessQuery({"token":getToken(), "location":location});

  useEffect(() => {
    setLoading(false);
    if (userAccessData && userAccessIsSuccess){
      try{
        setHaveCreateAccess(userAccessData.data.have_create_access)
      } catch {
        setHaveCreateAccess(false)
      }
    }
    setTimeout(() => {
      setLoading(true);
    }, 1000);
  }, [ userAccessData, userAccessIsSuccess, userAccessError]); 
  return (
    <>
      <Helmet>
        <title> DV Agent </title>
      </Helmet>
      <Container maxWidth="xxl">
        <Typography color="text.secondary" sx={{ mb: 2, fontSize: 14, fontWeight: 'bold' }}>
          ADD PROPERTY AND NETWORK
        </Typography>
        {loading ? (
          <Grid container spacing={2}>
            {!haveCreateAccess ? <Unauthorized/> :<Add/>}
          </Grid>
        ):(
          <Grid container spacing={2}>
            <PropertyViewCard/> 
          </Grid>
        )}
      </Container>
    </>
  );
}

